/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { scrollToTop } from "../constent/helper";

export const FeaturesCell = () => {
  return (
    <div className="call-outs Chome-container font-roboto xl:px-0 md:px-[24px] px-[16px] w-full grid sm:grid-cols-2 grid-cols-1 lg:gap-12 md:gap-[32px] sm:gap-[24px] gap-[16px]">
      <div className="call-out w-full">
        <p className="Chome-badge Chome-badge--teal">Looking For Donation?</p>
        <h3 className="home-type-subheading margin-t-16 !font-roboto">
          KWF Provides Foods
        </h3>
        <p className="call-out__copy !font-roboto text-justify">
          Every month, free cooked meals are delivered to over 5,000 citizens, ensuring no Pakistani goes to bed hungry.
        </p>
        <div className="call-out__actions">
          <Link
            className="primary-button w-max"
            to="/donation"
            onClick={() => scrollToTop()}
          >
            Donate Now
          </Link>
        </div>
      </div>
      <div className="call-out w-full">
        <p className="Chome-badge Chome-badge--teal">Here for inspiration?</p>
        <h3 className="home-type-subheading margin-t-16 !font-roboto">
          KWF Orphanages
        </h3>
        <p className="call-out__copy !font-roboto text-justify">
          Children in distress are taken into our care, receiving love,support
          and all the necessities for a brighter future.
        </p>
        <div className="call-out__actions">
          <Link
            className="primary-button w-max"
            to="/donation"
            onClick={() => scrollToTop()}
          >
            Donate Now
          </Link>
        </div>
      </div>
    </div>
  );
};
